import { JsonObject, JsonProperty } from 'json2typescript';

export const SCOPE_B2B_DONATION = 'B2BDONATION';

@JsonObject('TokenInfo')
export class TokenInfo {
    @JsonProperty('uuid', String, true)
    public uuid: string | null = null;

    @JsonProperty('shop-uuid', String, true)
    public shopGuid: string | null = null;

    @JsonProperty('shop-name', String, true)
    public shopName: string | null = null;

    @JsonProperty('scope', String, true)
    public scope: string | null = '';

    public isTokenUploadDonations(): boolean {
        return this.scope === SCOPE_B2B_DONATION;
    }
}
